import { Enums } from '@bode-canada/core';
import SoldPriceChart from './instances/sold-price';
import SoldPricePerSqft from './instances/sold-price-per-sqft';
import DaysOnMarket from './instances/days-on-market';
import NumberOfNewListings from './instances/number-of-new-listings';
import NumberOfSales from './instances/number-of-sales';
import WeeklyViews from './instances/weekly-views';

export default class ChartsFactory {
  static getChartByType(chartData, width) {
    switch (chartData.chartType) {
      case Enums.ChartTypeEnum.WEEKLY_VIEWS:
        return new WeeklyViews(chartData, width);
      case Enums.ChartTypeEnum.SOLD_PRICE_PER_SQFT:
        return new SoldPricePerSqft(chartData, width);
      case Enums.ChartTypeEnum.DAYS_ON_MARKET:
        return new DaysOnMarket(chartData, width);
      case Enums.ChartTypeEnum.NUMBER_OF_NEW_LISTINGS:
        return new NumberOfNewListings(chartData, width);
      case Enums.ChartTypeEnum.NUMBER_OF_SALES:
        return new NumberOfSales(chartData, width);
      case Enums.ChartTypeEnum.SOLD_PRICE:
      default:
        return new SoldPriceChart(chartData, width);
    }
  }
}
